import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';

import './offlineModeOverlay.less';

const OfflineModeOverlay = ({ isOnline }) => {
  if (isOnline) {
    return null;
  }

  return (
    <div className="offline-mode-overlay">
      <div className="offline-mode-overlay__inner">
        <div className="offline-mode-overlay__icon-container">
          <PriorityHighIcon />
        </div>

        <div>
          <Typography variant="h5">
            Straciłeś połączenie z internetem!
          </Typography>
        </div>

        <div>
          <Typography variant="overline">
            Będziesz mógł kontynuować, gdy odzyskasz połączenie.
          </Typography>
        </div>
      </div>
    </div>
  );
};

OfflineModeOverlay.propTypes = {
  isOnline: PropTypes.bool.isRequired,
};

const mapState = state => ({
  isOnline: state.appState.isOnline,
});

export default connect(mapState, null)(OfflineModeOverlay);
